import { Button } from "@delibrandev/utils";

export const GroupsSidebar = ({ styles, groups, selectedGroupId, onSelect, onNewGroup }) => {
  const renderGroups = () => {
    if (!groups?.length) {
      return <div className={styles.empty}>No hay grupos todavía</div>;
    }

    return groups.map((group) => {
      const active = group.optionGroupId === selectedGroupId;
      const name = group.name || "Sin nombre";
      const label = name.charAt(0).toUpperCase() + name.slice(1);

      return (
        <button
          key={group.optionGroupId}
          type="button"
          className={`${styles.groupItem} ${active ? styles.groupItemActive : ""}`}
          onClick={() => onSelect(group.optionGroupId)}
        >
          <span className={styles.groupName}>{label}</span>
          <span className={styles.groupMeta}>{(group.options || []).length} opciones</span>
        </button>
      );
    });
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <h5 className={styles.title}>Grupos</h5>
        <div className={styles.sidebarHeaderActions}>
          <Button text="Nuevo grupo" icon={null} customClass="customButtonColor1 w-100" action={onNewGroup} />
        </div>
      </div>

      <div className={styles.groupList}>{renderGroups()}</div>
    </aside>
  );
};
